import debounce from 'debounce';

let fn: EventListenerOrEventListenerObject;

export default {
  bind(el: any, binding: any) {
    fn = debounce((evt: Event) => {
      binding.value(evt);
    }, 100);
    window.addEventListener('scroll', fn);
  },
  unbind() {
    window.removeEventListener('scroll', fn);
  },
};
